<template>
  <v-dialog :value="dialogMessage" max-width="950px" height="400px"  persistent scrollable :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-card-title primary-title style="padding-top: 0px;padding-bottom: 0px;height: 65px;">
        <v-layout wrap justify-space-between align-center>
          <v-flex grow>
            <span class="headline">Pre-visualização da mensagem</span>
          </v-flex>
          <v-flex shrink>
            <v-btn icon fab @click="close()">
              <v-icon color="black">close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text style="padding-top:0px">
        <v-container fluid grid-list-md style="padding-top:0px">
          <v-layout row align-baseline wrap>
            <v-flex shrink v-if="this.config['type']"><span> Mandar mensagem no {{  translate('value.tasktemplate_automation_send_message_type').find((value) => value['value'] === this.config['type'])['text'] }}:</span>
            </v-flex>
            <v-flex shrink>
              <v-form ref="form">
                <v-text-field v-if="this.config['type'] === 'email'" id="msg_field" maxlength="190" counter="190" :label="translate('table.connections.field.email')" v-model="config['email']" :rules="requiredRule('E-mail')" validate-on-blur></v-text-field>
                <v-text-field v-else id="msg_field" :label="translate('table.connections.field.phone')" v-model="config['phone']" mask='(##) #####-####' :rules="requiredRule('WhatsApp')" validate-on-blur></v-text-field>
              </v-form>
            </v-flex>
            <v-flex xs12>
              <div class="e-content e-lib e-keyboard" id="automation_message_text" contenteditable="true" tabindex="0" style="outline: 0px solid transparent; padding: 15mm 15mm; border: 1px solid rgba(0, 0, 0, 0.12);" data-tribute="true">
              </div>
            </v-flex>
            <v-flex xs12>
              <span v-if="customFieldsFiles.length > 0">Será enviado um link juntamente com a mensagem acima para o seu cliente baixar os arquivos</span>
            </v-flex>
            <v-flex xs12>
              <v-form ref="apm_file_form">
                <v-flex xs12 sm6 v-for="(field, index) in customFieldsFiles" :key="index">
                  <p-file blackLabel :id="'cfa_' + index" :ref="'PFile_' + field['custom_field_id']" :label="field['title'] ? field['title'] : 'campo'" :custom_field_id="field['id']" @addFiles="(val)=>addFiles(val, field)" @deleteFiles="(file)=>deleteFiles(field, file)" :custom_field="field" :formDataFiles="formDataFiles" :canDelete="false" :required="true" validate-on-blur :rules="requiredManyRule(field['title'])">
                  </p-file>
                </v-flex>
              </v-form>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <!-- <v-btn v-if="!editMode" outline color="primary darken-2" @click="printDocument()"><v-icon>print</v-icon>{{this.$vuetify.breakpoint.smAndDown ? '' : 'IMPRIMIR'}}</v-btn>
        <v-btn v-if="!editMode" outline color="primary darken-2" @click="pdfDocument()"><v-icon>picture_as_pdf</v-icon>{{this.$vuetify.breakpoint.smAndDown ? '' : 'GERAR PDF'}}</v-btn> -->
        <v-btn outline color="primary darken-2" @click="sendAutomationMessage()" :loading="loading"><v-icon>send</v-icon>Enviar</v-btn>
        <v-btn class="mx-0" @click.native="close()" :loading="loading">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/* eslint-disable */
  import access from '../../mixin/access'
  import rules from '../../mixin/rules'
  import PFile from './PFile'
  
  export default {
    mixins: [access, rules],
    components: {PFile},
    data: () => ({
      values: {},
      indexIds: 0,
      loading: false,
      config: [],
      customFieldsFiles: [],
      // this. usado para usar dentro do watch
      this: null,
      basePath: process.env.API,
      formDataFiles: {},
      // idFile Armazena o ultimo id auxiliar dos arquivos, serve para poder saber de qual registro é o determinado arquivo, pois os registros de arquivos são adicionados antes de irem pro banco
      idFile: 0,
      // indexFile, usado para mostra que está no final dos arquivos, pois a medida que vai salvando vai adicionando 1, não pode usar o idFile para isso, pois caso tenha um arquivo muito grande e o usuário adicione outros arquivos durante o update, pode acabar tendo ids iguais para arquivos diferentes
      indexFile: 0
    }),
    methods: {
      openAutomationPreviewMessage () {
        this.values = this.$store.getters[`automationMessage/values`]
        // caso o index dos ids seja menor que a quantidade de ids, significa que possui automações de mensagem pendentes
        if (this.indexIds < this.values['tasktemplateAutomationIds'].length) this.getAutomationMessage()
      },
      getAutomationMessage () {
        this.loading = true
        this.config = []
        // Busca a lista de documentos personalizados da tarefa modelo da tarefa selecionada
        this.$http.get(`api/automation_preview_message/${this.values['taskId']}/${this.values['tasktemplateAutomationIds'][this.indexIds]}`).then((res) => {
          this.loading = false
          this.config = res.body['config']
          this.customFieldsFiles = res.body['customFieldsFiles']
          document.getElementById('automation_message_text').innerHTML = this.config['message']
        }, err => {
          console.log(err)
          this.loading = false
          this.$store.commit('snackbar/change_values', {text: 'Não foi possível carregar a visualização da menssagem, reporte o erro.', color: 'error', dialog: true})
        })
      },
      sendAutomationMessage () {
        // Verifica se tem algum campo de arquivo vazio, pois os arquivos são obrigatórios
        if (this.$refs.apm_file_form && !this.$refs.apm_file_form.validate()) {
          this.customFieldsFiles.forEach(customFieldFile => {
            let pfile = this.$refs[`PFile_${customFieldFile['custom_field_id']}`]
            if (pfile) pfile[0].checkRequired()
          })
          this.$store.commit('snackbar/change_values', {
            text: 'Por favor, inserir arquivos antes de salvar!',
            color: 'warning',
            dialog: true
          })
          return false
        }
        if (this.$refs.form && !this.$refs.form.validate()) {
          this.$store.commit('snackbar/change_values', {
            text: 'Por favor, corrija as validações antes de salvar!',
            color: 'warning',
            dialog: true
          })
          return false
        }
        if (document.getElementById('automation_message_text').innerText.replaceAll('\\n', '').replace(/\s/g, '') === '') {
          this.$store.commit('snackbar/change_values', {
            text: 'Favor inserir a mensagem',
            color: 'warning',
            dialog: true
          })
          return false
        }
        this.$store.commit('loader/change_dialog', true)
        this.loading = true
        this.saveFile().then((files) => {
          // Apos salvar o arquivo envia a mensagem para o usuário
          let params = {company_id: this.$auth.user().company_id, type: this.config['type'], email: this.config['email'], phone: this.config['phone'], message: document.getElementById('automation_message_text').innerText, tasktemplate_automation_id: this.values['tasktemplateAutomationIds'][this.indexIds], task_id: this.values['taskId'], hasFiles: this.customFieldsFiles.length > 0}
          this.$http.post(`api/send_automation_message`, params).then((res) => {
            this.$store.commit('snackbar/change_values', { text: 'Mensagem enviada com sucesso!', color: 'success', dialog: true })
            this.$store.commit('loader/change_dialog', false)
            this.close()
          }, err => {
            console.log(err)
            this.$store.commit('snackbar/change_values', {text: 'Não foi possível enviar a menssagem, reporte o erro.', color: 'error', dialog: true})
            this.$store.commit('loader/change_dialog', false)
            this.close()
          })
          console.log('sendAutomationMessagefiles', files)
          // se for diferente de criação significa que esta no gerenciamento da tarefa, logo deve mandar os sockets por arquivo
          if (Array.isArray(files)) {
            files.forEach(file => {
              this.$socket.emit('generalDetailsEvent', {
                data: file,
                notBroadcast: true,
                details: 'files',
                responseEvent: 'addSocketDetails',
                room: `tasks${file['task_id']}_manage`
              })
              // Emitindo evento para adicionar arquivo no campo personalizado
              this.$socket.emit('generalEvent', {
                data: file,
                responseEvent: 'addFileCustomField',
                room: `tasks${file['task_id']}_manage`
              })
              // linha utilizada para informar a Tela de Arquivos que este elemento veio da tela de Tarefas
              file['source'] = 2
              // Emitindo evento para adicionar arquivo à tela de arquivos
              this.$socket.emit('generalEvent', {
                data: file,
                responseEvent: 'addSocketItem',
                room: `files${file['company_id']}`
              })
            })
          }
        }, err => {
          console.log(err)
          // caso tenha sido barrado porque o plano excedeu o limite, mostra a msg de erro
          if (err.body.message.includes('limit|')) {
            // busca a memoria do plano do usuário
            let sizePlan = this.getterAccesses.find((res) => {
              return (res.id_text === 'files' && res.hasOwnProperty('size'))
            })
            // caso não tenha a variavel de tamanho, insere 0
            sizePlan = !sizePlan ? 0 : sizePlan['size']
            // transforma bit em mb
            let sumSizeFiles = (parseInt(sizePlan) - parseInt(err.body.message.split('|')[1])) / 1000000
            this.$store.commit('dialogPlan/change_values', {
              title: 'Memória excedida',
              text: `Esse arquivo ultrapassa o limite do seu plano, você tem apenas <strong>${Math.round(sumSizeFiles)}mb disponível</strong>. Aproveite e faça o upgrade agora mesmo!`,
              showDialog: true
            })
          } else {
            this.$store.commit('snackbar/change_values', { text: `Ocorreu um erro ao salvar os arquivos reporte o erro!`, color: 'error', dialog: true })
            this.$store.commit('loader/change_dialog', false)
          }
        })
      },
      deleteFiles (field, file) {
        // remove o arquivo do formDataFiles e do files
        this.formDataFiles[file['custom_field_id']].splice(this.formDataFiles[file['custom_field_id']].findIndex((val) => { return val.get('id') === file['id'] }), 1)
        field['files'].splice(field['files'].findIndex((val) => { return val['id'] === file['id'] }), 1)
      },
      addFiles (files, field) {
        let fileValues = {
          'custom_field_id': field['id'],
          'save_bd': false,
          'task_id': this.values['taskId'],
          'user_id': this.$auth.check() ? this.$auth.user().id : null,
          'company_id': field['company_id'],
          'connection_company_id': 25,
          'files': files
        }
        // return new Promise((resolve, reject) => {
        // let field = context.state.values.find((val) => { return val.id == payload['custom_field_id'] })
        // Caso não tenha a propriedade naquela posição cria com [] para pode incluir valores no array com push
        if (!this.formDataFiles.hasOwnProperty(fileValues['custom_field_id'])) this.formDataFiles[fileValues['custom_field_id']] = []
        // Caso não tenha a propriedade files adicionar, pois sem adicionar o front não estava reconhecendo
        if (!field.hasOwnProperty('files')) this.$set(field, 'files', [])
        // percorre todos os arquivos adicionados para inserilos na variavel com os devidos campos preenchidos
        if (fileValues['files'])
        for (var i = 0; i < fileValues['files'].length; i++) {
          let file = fileValues['files'][i]
          let fullName = file.name.split(/\.(?=[^\.]+$)/)
          // verifica se está em alguns formatos que não são aceitos
          if (['exe', 'sql', 'cs', 'msi'].includes(fullName[1])) {
            // adiciona os registro de arquvio para mostrar no front
            if (!Array.isArray(field['files'])) field['files'] = []
            field['files'].push({error: 'Formato do arquivo não aceito', id: this.idFile, id_text: fullName[0], size: file.size, extension: fullName[1], user_id: fileValues['user_id'], custom_field_id: fileValues['custom_field_id'], task_id: fileValues['task_id'], password: null, create: true, loading_upload: false, loading_value_upload: 0})
          } else {
            let formData = new FormData()
            this.idFile--
            this.indexFile++
            // Monta os dados no formData que irão para a tabela file
            formData.append('id', this.idFile)
            formData.append('file', file, file.name)
            formData.append('custom_field_id', fileValues['custom_field_id'])
            formData.append('task_id', fileValues['task_id'])
            formData.append('user_id', fileValues['user_id'])
            formData.append('company_id', fileValues['company_id'])
            formData.append('connection_company_id', fileValues['connection_company_id'])
            // Inclui um formdata completo para cada arquivo 
            this.formDataFiles[fileValues['custom_field_id']].push(formData)
            // adiciona os registro de arquvio para mostrar no front
            if (!Array.isArray(field['files'])) field['files'] = []
            field['files'].push({id: this.idFile, id_text: fullName[0], size: file.size, extension: fullName[1], user_id: fileValues['user_id'], custom_field_id: fileValues['custom_field_id'], task_id: fileValues['task_id'], password: null, create: true, loading_upload: false, loading_value_upload: 0})
          }
        }
      },
      saveFile () {
        return new Promise((resolve, reject) => {
          // verifica se de salvar no banco
          // caso não tenha arquivos já fecha o processo
          if (this.indexFile === 0) {
            resolve(true)
          }
          // armazena todos os arquivos adicionados, para mandar na resposta quando terminar de salvar todos
          let resFiles = []
          // insere um indexFile dentro do stateFiles para armazenar o index e ir decrementando, é necessário pois quando é adicionado varias tarefas de uma vez(varios cliente), precisa ter o index para cada tarefa
          let indexFile = 0
          indexFile = this.indexFile
          // caso seja para salvar no banco, já adiciona o arquivo
          for (var key in this.formDataFiles) {
            // Busca o campo personalizado do arquivo para substituir as informações
            let customField = this.customFieldsFiles.find((val) => { return val.id == key })
            // pega todos os arquivos
            let stateFiles = this.formDataFiles[key]
            // Faz um loop em todos os arquivo q
            stateFiles.forEach((stateFile) => {
              // Pega o arquivo que será adicionado no momento
              let customFieldFiles = customField['files'].find((val) => { return val.id == stateFile.get('id') })
              if (customFieldFiles) {
                // seta true para o loading começar a rodar
                customFieldFiles['loading_upload'] = true
                this.$http.post('api/customField/upload', stateFile, {
                  progress (e) {
                    if (e.lengthComputable) {
                      customFieldFiles['loading_value_upload'] = Math.floor(e.loaded / e.total * 100)
                    }
                  }
                }).then(res => {
                  indexFile--
                  // context.state.indexFile--
                  stateFile = null
                  customFieldFiles['loading_upload'] = false
                  // Substitui os valoresde cada arquivo assim que ele for salvo
                  // ja coloca o create false, pois depois que salva o arquvios não fica mais em modo de criação
                  Object.assign(customFieldFiles, res.body, {create: false});
                  resFiles.push(res.body)
                  // caso o indexFile seja 0, significa que já chegou no ultimo arquivo, retornando que deu certo
                  if (indexFile === 0) {
                    resolve(resFiles)
                  }
                }, err => {
                  console.log(err)
                  indexFile--
                  // context.state.indexFile--
                  stateFile = null
                  customFieldFiles['loading_upload'] = false
                  if (err.body.message.includes('limit|')) {
                    // Substitui os valores de cada arquivo assim que ele for salvo
                    // ja coloca o create false, pois depois que salva o arquvios não fica mais em modo de criação
                    Object.assign(customFieldFiles, {error: 'Limite de memória do plano exedida'});
                  } else {
                    Object.assign(customFieldFiles, {error: 'Não foi possível incluir o arquivo'});
                  }
                  // caso o indexFile seja 0, significa que já chegou no ultimo arquivo, retornando que deu certo
                  reject(err)
                })
                // else - caso não tenha encontrado o arquivos então tira ele da lista
              } else {
                indexFile--
                stateFile = null
                // caso o indexFile seja 0, significa que já chegou no ultimo arquivo, retornando que deu certo
                if (indexFile === 0) {
                  resolve(resFiles)
                }
              }
            })
          }
        })
      },
      close () {
        this.indexIds++
        this.loading = false
        this.config = []
        // caso o usuário cancele ainda pode ter automações pendentes portanto verifica se possui alguma pendente
        if (this.indexIds < this.values['tasktemplateAutomationIds'].length) {
          this.$store.commit('automationMessage/change_values', {dialog: true})
          this.getAutomationMessage()
        } else {
          this.indexIds = 0
        }
        this.$store.commit('automationMessage/change_values', {dialog: false})
      }
    },
    computed: {
      dialogMessage () {
        return this.$store.getters[`automationMessage/dialog`] || false
      }
    },
    watch: {
      // quando o dialogMessage é alterado chama a função openAutomationPreviewMessage
      dialogMessage: {
        handler: 'openAutomationPreviewMessage'
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/shared/PAutomationPreviewMessage.vue